define('PageView',['underscore','jquery','backbone','SubView','InternalLinkView','SelectView','BtnSwitchView','ProductBlockView','InputView','UrlFactory','TagCommander',
        'InternalFormView'],
    function (_,$,Backbone,SubView,InternalLinkView,SelectView,BtnSwitchView,ProductBlockView,InputView,UrlFactory,TagCommander, InternalFormView) {

    //
    // prototype PageView
    //

    var PageView = Backbone.View.extend({

        pageName:'default',
        className:'page',
        backbonePattern:'View',
        displayAsModal:false,
        pageOptions:{},
        initialize:function(options){
            var self = this, pageName = self.pageName;

            self.subviews = [];

            self.className += ' '+pageName;

            self.pageOptions = _.defaults(options,{});;

            //Backbone.View.apply(self, [options]);
            // initialise les liens internes
            self.initializeLinksOfPage();
            self.initializeFormsOfPage();
            // initialisation des selects
            self.attachViews(SelectView.initializeSelectsOfView(self));
            //

            // initialisation des blocks produit
            self.attachViews(ProductBlockView.initializeProductBlocksOfView(self));

            // initialisation des inputs
            self.attachViews(InputView.initializeInputsOfView(self));

        },
        initialRender:function(){},
        initializeLinksOfPage:function(){
            // initialise les liens internes
            var self = this;
            InternalLinkView.initializeLinksOfView(self);
        },
        initializeFormsOfPage:function(){
            // initialise les liens internes
            var self = this;
            InternalFormView.initializeFormsOfView(self);
        },
        startPageTagCommander:function(options){
            TagCommander.LoadPage(this.pageName,options);
        },
        //getTagCommanderUrl:function(options){
        //    return UrlFactory.getUrl('tc_vars',{},false,true);
        //},
        microtemplate:function(options){
            this.pageOptions = _.defaults(options,{});;
        },
        reloadMeta:function(){
            this.initialMetaTitle();
            this.startPageTagCommander(this.pageOptions)
        },
        initialMetaTitle:function(){
            // default meta title fallback
            document.title = app.c('_META_TITLE_');
        },
    }).extend(SubView);


    return PageView;
});
